import { HotelProduct } from '@/api/Cart/cart.interfaces';
import { Money } from '@libs/money/money.interfaces';
import { t } from '@shared/helpers/translation';

export const mapGolfSubLabel = (product: HotelProduct): string => {
    const rooms = product.Rooms.length;
    return `${rooms} ${t({ key: 'shared.ticket', keyPlural: 'shared.ticket', count: rooms })}`;
};

export const mapGolfPrice = (product: HotelProduct): Money => {
    return {
        Amount: product.Price.Amount,
        Currency: product.Price.Currency,
    };
};
